import { render, staticRenderFns } from "./AxiosHelper.vue?vue&type=template&id=371cabda&"
import script from "./AxiosHelper.vue?vue&type=script&lang=js&"
export * from "./AxiosHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports